// extracted by mini-css-extract-plugin
export default {"main":"_4c0cbc67a1a633098958b8d9d4efe727-scss"};